document.documentElement.classList.remove('no-js');
/* red de seguridad: si algo no se anima en 2,5 s, igual se muestra */
setTimeout(function(){ try{ document.querySelectorAll('.reveal:not(.in)').forEach(function(e){ e.classList.add('in'); }); }catch(e){ document.documentElement.classList.add('mp-js-failed'); } }, 2500);
window.addEventListener('error', function(ev){ if(ev && ev.filename && /\/mp\.js/.test(ev.filename)) document.documentElement.classList.add('mp-js-failed'); });

/* ============ SELECTOR DE PACKS (widget reconstruido, una o varias cajas sincronizadas) ============ */
window.MP_SELECTED_IDX = window.MP_SELECTED_IDX | 0;
(function(){
  var MES=['enero','febrero','marzo','abril','mayo','junio','julio','agosto','septiembre','octubre','noviembre','diciembre'];
  function biz(n){ var d=new Date(), c=0; while(c<n){ d.setDate(d.getDate()+1); var w=d.getDay(); if(w!==0&&w!==6) c++; } return d; }
  var G = window.mpBoxes = window.mpBoxes || [];
  function txt(el, v){ if(!el) return; v = v == null ? '' : String(v); if(el.textContent !== v) el.textContent = v; }
  function disp(el, on){ if(!el) return; var v = on ? '' : 'none'; if(el.style.display !== v) el.style.display = v; }
  function init(R){
    if(R.getAttribute('data-bound')) return; R.setAttribute('data-bound','1');
    var D; try{ D = JSON.parse(document.getElementById(R.id + '-data').textContent); }catch(e){ return; }
    var S = R.closest('.shopify-section') || document.body;
    var P = {}; for(var i=0;i<D.p.length;i++){ P[D.p[i].n] = D.p[i]; }
    function q(sel){ return R.querySelector(sel); }
    function each(sel, fn){ Array.prototype.forEach.call(R.querySelectorAll(sel), fn); }
    var et = q('[data-eta]');
    if(et){ var ea=biz(3), eb=biz(7);
      et.innerHTML = (ea.getMonth()===eb.getMonth()) ? '<b>'+ea.getDate()+'</b> y el <b>'+eb.getDate()+' de '+MES[eb.getMonth()]+'</b>'
        : '<b>'+ea.getDate()+' de '+MES[ea.getMonth()]+'</b> y el <b>'+eb.getDate()+' de '+MES[eb.getMonth()]+'</b>'; }
    /* foto 1 de la galería según el pack (si el pack tiene foto propia) */
    var tr = (D.track && D.track !== 'none') ? S.querySelector('#' + D.track) : null, sl = tr ? tr.querySelector('img') : null;
    var thw = (D.thumbs && D.thumbs !== 'none') ? S.querySelector('#' + D.thumbs) : null, th = thw ? thw.querySelector('img') : null;
    var o1 = sl ? sl.getAttribute('src') : null, o1s = sl ? (sl.getAttribute('srcset') || '') : '', o1t = th ? th.getAttribute('src') : null;
    function hero(n){
      if(!sl) return; var p = P[n], hu = p && p.hero;
      var u = hu || o1, us = hu ? '' : o1s, ut = hu || o1t;
      if(sl.getAttribute('src') !== u){ sl.setAttribute('src', u); sl.setAttribute('srcset', us); if(tr && tr.scrollLeft > 2) tr.scrollLeft = 0; }
      if(th && ut && th.getAttribute('src') !== ut) th.setAttribute('src', ut);
    }
    var cur = D.def || 2;
    var me = { k: D.sync, set: function(n){ if(n !== cur && P[n]) set(n, true, true); } };
    G.push(me);
    function bcast(n){ for(var i=0;i<G.length;i++){ if(G[i] !== me && G[i].k === me.k){ try{ G[i].set(n); }catch(x){} } } }
    function set(n, anim, silent){
      var p = P[n]; if(!p) return; cur = n;
      each('.mlr-row', function(r){ var on = (r.getAttribute('data-n') === String(n)); if(r.classList.contains('sel') !== on) r.classList.toggle('sel', on); r.setAttribute('aria-checked', on ? 'true' : 'false'); });
      txt(q('[data-now]'), p.pr);
      var w = q('[data-was]'); txt(w, p.was); disp(w, !!p.was);
      txt(q('[data-bsave]'), p.sv); disp(q('[data-badge]'), !!p.sv);
      txt(q('[data-atc-p]'), p.pr);
      var aw = q('[data-atc-w]'); txt(aw, p.was); disp(aw, !!p.was);
      each('.mlr-g', function(g){ var on = (n >= parseInt(g.getAttribute('data-min'), 10)), was = g.classList.contains('on');
        if(on === was) return; g.classList.toggle('on', on);
        if(anim){ g.classList.remove('a-un'); g.classList.remove('a-lk'); void g.offsetWidth; g.classList.add(on ? 'a-un' : 'a-lk');
          setTimeout(function(){ g.classList.remove('a-un'); g.classList.remove('a-lk'); }, 800); } });
      if(anim) hero(n); /* al cargar se ve la portada; la foto del pack entra al elegirlo */
      window.MP_SELECTED_IDX = n - 1; window.MP_SELECTED_QTY = p.q || n;
      try{ document.dispatchEvent(new CustomEvent('mp:pack', { detail: { n: n, p: p } })); }catch(x){}
      if(!silent) bcast(n);
    }
    R.addEventListener('click', function(e){
      var row = e.target.closest ? e.target.closest('.mlr-row') : null;
      if(row && R.contains(row)){ var n = parseInt(row.getAttribute('data-n'), 10); if(n !== cur) set(n, true); return; }
      var at = e.target.closest ? e.target.closest('[data-atc]') : null;
      if(at && R.contains(at)){ e.preventDefault(); window.mpBuy(at); }
    });
    R.addEventListener('keydown', function(e){
      var row = e.target.closest ? e.target.closest('.mlr-row') : null; if(!row) return;
      var k = e.key;
      if(k === 'Enter' || k === ' '){ e.preventDefault(); row.click(); }
      else if(/^Arrow/.test(k)){ e.preventDefault();
        var ns = D.p.map(function(x){ return x.n; }), ix = ns.indexOf(cur) + ((k === 'ArrowDown' || k === 'ArrowRight') ? 1 : -1);
        if(ix < 0) ix = ns.length - 1; if(ix >= ns.length) ix = 0;
        set(ns[ix], true); var nr = R.querySelector('.mlr-row[data-n="' + ns[ix] + '"]'); if(nr) nr.focus(); }
    });
    set(cur, false, true);
  }
  function boot(){ document.querySelectorAll('[data-mp-mlr]').forEach(init); }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();

/* ============ COMPRA: abre el formulario de la app COD (Releasit) con la oferta elegida ============ */
var RSI_BTN = '._rsi-buy-now-button, #rsi_buy_now_button:not(.rsi_floating)';
var RSI_MODAL = '#_rsi-cod-form-modal._rsi-cod-form-modal-open, dialog#rsi_form_wrapper[open]', RSI_OFFER = '._rsi-quantity-offers-offer-container', RSI_SEL = '_rsi-quantity-offers-selected';
var mpSyncing = false;
function mpSyncReleasit(){
  if(mpSyncing) return; mpSyncing = true;
  var t0 = Date.now(), done = false, mo = null, clicks = 0, last = 0;
  function finish(){ done = true; mpSyncing = false; if(mo){ mo.disconnect(); mo = null; } }
  function apply(){
    if(done) return true;
    if(!document.querySelector(RSI_MODAL)) return false;
    var offers = document.querySelectorAll(RSI_OFFER); if(!offers.length) return false;
    var el = offers[window.MP_SELECTED_IDX | 0]; if(!el){ finish(); return true; }
    if(el.classList.contains(RSI_SEL) || el.querySelector('.' + RSI_SEL)){ finish(); return true; }
    var target = el.querySelector('._rsi-quantity-offers-offer') || el;
    if(clicks < 6 && Date.now() - last > 250){ clicks++; last = Date.now(); try{ target.click(); }catch(e){} }
    return false;
  }
  if(apply()) return;
  if(window.MutationObserver){ mo = new MutationObserver(function(){ if(apply()) return; if(Date.now() - t0 > 6000) finish(); });
    mo.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] }); }
  (function poll(){ if(done) return; if(apply()) return; if(Date.now() - t0 > 6000){ finish(); return; } setTimeout(poll, 150); })();
}
document.addEventListener('click', function(e){
  var h = document.getElementById('mpReleasitHost'); if(!h || !e.target || !e.target.closest) return;
  var t = e.target.closest(RSI_BTN); if(t && h.contains(t)) mpSyncReleasit();
}, true);
window.mpOpenReleasit = function(){ var h = document.getElementById('mpReleasitHost'), b = h && h.querySelector(RSI_BTN); if(!b) return false; b.click(); return true; };
window.mpBuy = function(btn){
  if(window.mpOpenReleasit()) return;
  /* sin la app COD activa: carrito normal de Shopify con las unidades del pack */
  var v = window.MP_VARIANT; if(!v){ window.location.href = '/cart'; return; }
  if(btn){ btn.disabled = true; btn.style.opacity = '.7'; }
  fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, credentials: 'same-origin',
    body: JSON.stringify({ items: [{ id: v, quantity: window.MP_SELECTED_QTY || 1 }] }) })
    .then(function(r){ if(!r.ok) throw new Error('add'); window.location.href = '/checkout'; })
    .catch(function(){ if(btn){ btn.disabled = false; btn.style.opacity = '1'; } window.location.href = '/cart'; });
};

/* ============ CTAs "Pruébalo Hoy" / carrito de la cabecera: llevan al selector de packs ============ */
document.addEventListener('click', function(e){
  var a = e.target.closest ? e.target.closest('a[href="#psx-buy"], a[href="#psx-oferta"], a[href^="#psx"]') : null;
  if(!a) return; var t = document.querySelector(a.getAttribute('href')); if(!t) return;
  e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' });
});

/* ============ POPUP de bienvenida (reconstruido; sus botones llevan a la oferta) ============ */
(function(){
  var pop = document.getElementById('mpwPop'); if(!pop) return;
  var KEY = 'mpwSeen', seen = false;
  try{ seen = sessionStorage.getItem(KEY) === '1'; }catch(e){}
  function close(){ if(pop.classList.contains('open')) pop.classList.remove('open'); try{ sessionStorage.setItem(KEY, '1'); }catch(e){} }
  pop.addEventListener('click', function(e){
    if(e.target === pop || (e.target.closest && e.target.closest('[data-mpw-close]'))){ close(); return; }
    var b = e.target.closest ? e.target.closest('[data-mpw-go]') : null;
    if(b){ close(); var t = document.querySelector(b.getAttribute('data-mpw-go') || '#psx-buy'); if(t) t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
  });
  if(!seen && !(window.Shopify && window.Shopify.designMode)){
    setTimeout(function(){ if(!pop.classList.contains('open')) pop.classList.add('open'); }, parseInt(pop.getAttribute('data-delay'), 10) || 4000);
  }
})();


/* ==== top ==== */
try{
(function(){
  var KEY='pxCdEnd', end=0, now=Date.now(); try{ end=parseInt(localStorage.getItem(KEY)||'0',10); }catch(e){}
  if(!end||end<now){ end=now+2*3600*1000; try{ localStorage.setItem(KEY,String(end)); }catch(e){} }
  var h=document.getElementById('pxTh'),m=document.getElementById('pxTm'),s=document.getElementById('pxTs');
  function put(el,v){ var n=el.firstChild; if(n&&n.nodeType===3&&!n.nextSibling){ if(n.nodeValue!==v) n.nodeValue=v; } else el.textContent=v; }
  function pad(n){return n<10?'0'+n:''+n}
  function tick(){
    var d=Math.max(0,end-Date.now());
    if(d===0){ end=Date.now()+2*3600*1000; try{ localStorage.setItem(KEY,String(end)); }catch(e){} d=end-Date.now(); }
    var hh=Math.floor(d/3600000), mm=Math.floor(d%3600000/60000), ss=Math.floor(d%60000/1000);
    if(h){put(h,pad(hh));put(m,pad(mm));put(s,pad(ss));}
  }
  tick(); setInterval(tick,1000);
  var cart=document.getElementById('pxTcart');
  if(cart){ cart.addEventListener('click',function(){
    if(window.mlCartOpen){ window.mlCartOpen(); return; }
    
    window.location.href='/cart';
  }); }
  var mn=document.getElementById('pxTmenu');
  if(mn){ mn.addEventListener('click',function(){
    
    window.location.href='/collections/all';
  }); }
})();

}catch(e){ if(window.console) console.error(e); }

/* ==== hero ==== */
try{
(function(){
  var s=document.querySelector('.mp-sec--hero');
  if(!s)return;
  var cur='53639907246346';
  var pr=s.querySelector('#pxPrice'), wa=s.querySelector('#pxWas'), sv=s.querySelector('#pxSave'), ap=s.querySelector('#pxAtcP'), aw=s.querySelector('#pxAtcW');
  s.querySelectorAll('.px-pk').forEach(function(p){
    p.addEventListener('click',function(){
      s.querySelectorAll('.px-pk').forEach(function(x){x.classList.remove('sel')});
      p.classList.add('sel');
      cur=p.getAttribute('data-v');
      if(pr)pr.textContent=p.getAttribute('data-p');
      if(wa)wa.textContent=p.getAttribute('data-w');
      if(sv)sv.textContent='Oferta de Verano - Ahorra '+p.getAttribute('data-a');
      if(ap)ap.textContent=p.getAttribute('data-p');
      if(aw)aw.textContent=p.getAttribute('data-w');
    });
  });
  window.pxCurVariant=function(){return cur};
  var track=s.querySelector('#pxTrack'), tbs=s.querySelectorAll('#pxThumbs button'), tc=0;
  function mark(i){ if(i===tc)return; tc=i; tbs.forEach(function(x,j){x.classList.toggle('act',j===tc)}); if(tbs[tc]&&tbs[tc].scrollIntoView)tbs[tc].scrollIntoView({block:'nearest',inline:'nearest',behavior:'smooth'}); }
  if(track){ track.addEventListener('scroll',function(){ var i=Math.round(track.scrollLeft/track.clientWidth); if(i>=0&&i<tbs.length)mark(i); },{passive:true}); }
  tbs.forEach(function(b,k){ b.addEventListener('click',function(){ if(track)track.scrollTo({left:k*track.clientWidth,behavior:'smooth'}); }); });
  var del=s.querySelector('#pxDel');
  if(del){ var d=new Date(Date.now()+6*864e5); del.textContent=d.toLocaleDateString('es-MX',{day:'numeric',month:'long'}); }
  var atc=s.querySelector('#pxAtc');
  if(atc){ atc.addEventListener('click',function(){
    var b=this; b.disabled=true; b.style.opacity='.7';
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:cur,quantity:1}]})})
      .then(function(r){return r.json()})
      .then(function(){ b.disabled=false; b.style.opacity='1'; if(window.mlCartOpen){window.mlCartOpen();}else{window.location.href='/cart';} })
      .catch(function(){ b.disabled=false; b.style.opacity='1'; });
  }); }
  var rv=s.querySelector('[data-pxgoto]');
  if(rv){ rv.addEventListener('click',function(){ var t=document.querySelector(this.getAttribute('data-pxgoto')); if(t)t.scrollIntoView({behavior:'smooth'}); }); }
})();

}catch(e){ if(window.console) console.error(e); }

/* ==== confianza ==== */
try{
(function(){
  var s=document.querySelector('.mp-sec--confianza');
  if(!s)return;
  var tr=s.querySelector('#pxVtr'), dw=s.querySelector('#pxVdots');
  if(!tr||!dw)return;
  var allVideos = Array.prototype.slice.call(tr.querySelectorAll('video'));
  tr.querySelectorAll('.pxV-it').forEach(function(it){
    var vid = it.querySelector('video');
    var play = it.querySelector('.pxV-play');
    play.addEventListener('click', function(){
      allVideos.forEach(function(v){ if(v!==vid){ v.pause(); v.currentTime=0; } });
      tr.querySelectorAll('.pxV-play').forEach(function(p){ if(p!==play) p.classList.remove('hide'); });
      vid.muted = false;
      vid.controls = true;
      vid.play();
      play.classList.add('hide');
    });
    vid.addEventListener('pause', function(){ play.classList.remove('hide'); });
    vid.addEventListener('ended', function(){ play.classList.remove('hide'); });
  });
  var pages=1;
  function build(){
    pages=Math.max(1,Math.round((tr.scrollWidth - tr.clientWidth)/tr.clientWidth)+1);
    if(tr.scrollWidth<=tr.clientWidth+4)pages=1;
    dw.innerHTML='';
    for(var i=0;i<pages;i++){
      (function(k){
        var b=document.createElement('button');
        b.type='button'; b.setAttribute('aria-label','Página '+(k+1));
        b.addEventListener('click',function(){ tr.scrollTo({left:k*tr.clientWidth,behavior:'smooth'}); });
        dw.appendChild(b);
      })(i);
    }
    sync();
  }
  function sync(){
    var max=tr.scrollWidth-tr.clientWidth;
    var i=max<=0?0:Math.min(pages-1,Math.round(tr.scrollLeft/max*(pages-1)));
    var bs=dw.children;
    for(var j=0;j<bs.length;j++)bs[j].classList.toggle('on',j===i);
  }
  tr.addEventListener('scroll',function(){requestAnimationFrame(sync)},{passive:true});
  window.addEventListener('resize',build);
  build();
})();

}catch(e){ if(window.console) console.error(e); }

/* ==== stats ==== */
try{
(function(){
  var s=document.querySelector('.mp-sec--stats');
  if(!s)return;
  var done=false;
  function run(){
    if(done)return; done=true;
    s.querySelectorAll('[data-pxn]').forEach(function(el){
      var t=parseInt(el.getAttribute('data-pxn'),10), st=Date.now();
      (function anim(){
        var p=Math.min(1,(Date.now()-st)/1400);
        var v=String(Math.round(t*(1-Math.pow(1-p,3)))), nd=el.firstChild; if(nd&&nd.nodeType===3&&!nd.nextSibling){ if(nd.nodeValue!==v) nd.nodeValue=v; } else el.textContent=v;
        if(p<1)requestAnimationFrame(anim);
      })();
    });
  }
  function vis(){
    var r=s.getBoundingClientRect();
    return r.top<window.innerHeight*0.85 && r.bottom>0;
  }
  function chk(){ if(!done&&vis())run(); }
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(en){ en.forEach(function(e){ if(e.isIntersecting){run(); io.disconnect();} }); },{threshold:.15});
    io.observe(s);
  }
  /* Fallback real: Horizon scrollea dentro de .page-wrapper — escuchar en captura cubre cualquier contenedor */
  document.addEventListener('scroll',function(){ if(!done)requestAnimationFrame(chk); },{passive:true,capture:true});
  window.addEventListener('touchmove',function(){ if(!done)requestAnimationFrame(chk); },{passive:true});
  chk();
})();

}catch(e){ if(window.console) console.error(e); }

/* ==== compuestos ==== */
try{
(function(){
  var s=document.querySelector('.mp-sec--compuestos');
  var tr=s&&s.querySelector('#pxKtr');
  if(!tr)return;
  s.querySelectorAll('[data-d]').forEach(function(b){
    b.addEventListener('click',function(){
      var w=tr.querySelector('.pxK-cd').offsetWidth+16;
      tr.scrollBy({left:parseInt(b.getAttribute('data-d'),10)*w,behavior:'smooth'});
    });
  });
})();

}catch(e){ if(window.console) console.error(e); }

/* ==== historias ==== */
try{
(function(){
  var s=document.querySelector('.mp-sec--historias');
  var tr=s&&s.querySelector('#pxHtr');
  if(!tr)return;
  function step(){ return tr.querySelector('.pxH-cd').offsetWidth+12; }
  s.querySelectorAll('[data-d]').forEach(function(b){
    b.addEventListener('click',function(){
      tr.scrollBy({left:parseInt(b.getAttribute('data-d'),10)*step(),behavior:'smooth'});
    });
  });
  var dw=s.querySelector('#pxHdots'), cds=tr.querySelectorAll('.pxH-cd');
  if(dw){
    cds.forEach(function(_,k){
      var b=document.createElement('button');
      b.type='button'; b.setAttribute('aria-label','Reseña '+(k+1));
      b.addEventListener('click',function(){ tr.scrollTo({left:k*step(),behavior:'smooth'}); });
      dw.appendChild(b);
    });
    function sync(){
      var i=Math.max(0,Math.min(cds.length-1,Math.round(tr.scrollLeft/step())));
      for(var j=0;j<dw.children.length;j++)dw.children[j].classList.toggle('on',j===i);
    }
    tr.addEventListener('scroll',function(){requestAnimationFrame(sync)},{passive:true});
    sync();
  }
})();

}catch(e){ if(window.console) console.error(e); }

/* ==== beneficios ==== */
try{
(function(){
  var s=document.querySelector('.mp-sec--beneficios');
  if(!s)return;
  s.querySelectorAll('.pxB-cd').forEach(function(cd){
    var b=cd.querySelector('.pxB-pl');
    function tg(){ cd.classList.toggle('open'); b.textContent=cd.classList.contains('open')?'−':'+'; }
    b.addEventListener('click',tg);
  });
})();

}catch(e){ if(window.console) console.error(e); }

/* ==== viaje ==== */
try{
(function(){
  function init(){
    var rail=document.querySelector('.mp-sec--viaje .pxJ-tl');
    if(!rail||rail.__tl)return;rail.__tl=1;
    var cps=rail.querySelectorAll('.pxJ-wk');
    var tick=false;
    function upd(){
      tick=false;
      var r=rail.getBoundingClientRect();
      var anchor=window.innerHeight*0.58;
      var p=Math.max(0,Math.min(anchor-r.top,r.height-28));
      var pv=p.toFixed(0)+'px'; if(rail.style.getPropertyValue('--tlprog')!==pv) rail.style.setProperty('--tlprog',pv);
      for(var i=0;i<cps.length;i++){
        var cr=cps[i].getBoundingClientRect();
        var on=(cr.top-r.top)<p; if(cps[i].classList.contains('on')!==on) cps[i].classList.toggle('on',on);
      }
    }
    document.addEventListener('scroll',function(){if(!tick){tick=true;requestAnimationFrame(upd)}},{passive:true,capture:true});
    window.addEventListener('resize',upd);
    upd();
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init)}else{init()}
})();

}catch(e){ if(window.console) console.error(e); }

/* ==== razones ==== */
try{
(function(){
  var s=document.querySelector('.mp-sec--razones');
  var tr=s&&s.querySelector('#pxRtr');
  if(!tr)return;
  s.querySelectorAll('[data-d]').forEach(function(b){
    b.addEventListener('click',function(){
      var w=tr.querySelector('.pxR-cd').offsetWidth+16;
      tr.scrollBy({left:parseInt(b.getAttribute('data-d'),10)*w,behavior:'smooth'});
    });
  });
})();

}catch(e){ if(window.console) console.error(e); }

/* ==== oferta ==== */
try{
(function(){
  var s=document.querySelector('.mp-sec--oferta');
  if(!s)return;
  var cur='53639907246346';
  var ap=s.querySelector('#pxOAtcP'), aw=s.querySelector('#pxOAtcW');
  s.querySelectorAll('.pxO-pk').forEach(function(p){
    p.addEventListener('click',function(){
      s.querySelectorAll('.pxO-pk').forEach(function(x){x.classList.remove('sel')});
      p.classList.add('sel');
      cur=p.getAttribute('data-v');
      if(ap)ap.textContent=p.getAttribute('data-p');
      if(aw)aw.textContent=p.getAttribute('data-w');
    });
  });
  var vtr=s.querySelector('.pxO-vtr'), vdw=s.querySelector('#pxOvdots');
  if(vtr&&vdw){
    var vits=vtr.querySelectorAll('.pxO-vit');
    function vstep(){ return vits[0].offsetWidth+12; }
    vits.forEach(function(_,k){
      var b=document.createElement('button');
      b.type='button'; b.setAttribute('aria-label','Video '+(k+1));
      b.addEventListener('click',function(){ vtr.scrollTo({left:k*vstep(),behavior:'smooth'}); });
      vdw.appendChild(b);
    });
    function vsync(){
      var i=Math.max(0,Math.min(vits.length-1,Math.round(vtr.scrollLeft/vstep())));
      for(var j=0;j<vdw.children.length;j++)vdw.children[j].classList.toggle('on',j===i);
    }
    vtr.addEventListener('scroll',function(){requestAnimationFrame(vsync)},{passive:true});
    vsync();
  }
  var del=s.querySelector('.pxODel');
  if(del){ var d=new Date(Date.now()+6*864e5); del.textContent=d.toLocaleDateString('es-MX',{day:'numeric',month:'long'}); }
  var atc=s.querySelector('#pxOAtc');
  if(atc){ atc.addEventListener('click',function(){
    var b=this; b.disabled=true; b.style.opacity='.7';
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:cur,quantity:1}]})})
      .then(function(r){return r.json()})
      .then(function(){ b.disabled=false; b.style.opacity='1'; if(window.mlCartOpen){window.mlCartOpen();}else{window.location.href='/cart';} })
      .catch(function(){ b.disabled=false; b.style.opacity='1'; });
  }); }
})();

}catch(e){ if(window.console) console.error(e); }

/* ==== shift ==== */
try{
(function(){
  var s=document.querySelector('.mp-sec--shift');
  var b=s&&s.querySelector('[data-pxgoto]');
  if(b){ b.addEventListener('click',function(){ var t=document.querySelector(this.getAttribute('data-pxgoto')); if(t)t.scrollIntoView({behavior:'smooth'}); }); }
})();

}catch(e){ if(window.console) console.error(e); }